// 项目设置模块
export default {
    SetUp: {
        AnswerSet: '答题设置',
        QualitySettings: '质量设置',
        PublicSettings: '公开设置',
        OtherSettings: '其他设置',
        CanOnly: '只能',
        EveryHour: '每小时',
        EveryDay: '每天',
        Weekly: '每周',
        Monthly: '每月',
        Thanking: '您的答卷已提交，感谢您的参与！',
        OnlyWeChatAnswerQuestions: '只允许微信答题',
        WeChatRestrictions: '每个微信答题次数限制',
        PleaseSelect: '请选择',
        Answer: '答题',
        PleaseEnterContent: '请输入内容',
        Times: '次',
        ComputerOrPhoneRestrictions: '每台电脑或手机答题次数限制',
        IPRestrictions: '每个IP答题次数限制',
        ActivateAccessPassword: '启动访问密码',
        EnterTheAccessPassword: '请输入访问密码',
        MailOnly: '只有邮件邀请的受访者可回答',
        SetTime: '设置开始/结束时间',
        SetStartTime: '设置开始时间',
        NoRestrictions: '没有限制',
        SetEndTime: '设置结束时间',
        EndTimeGreaterThanStartTime: '结束时间需要大于开始时间',
        SetDataUpperLimit: '设定答题数据上限',
        Collect: '收集',
        EndOfData: '份数据时结束',
        ControlPageFillingTime: '控制页面填写时间',
        Limitation: '限制',
        TimedOutAutomaticSubmission: '分钟内完成问卷 , 超时将所有内容自动提交',
        SetQuotas: '设置配额',
        PublicSettings: '公开设置',
        ShareButton: '显示“分享”按钮，可分享链接至更多社交网站(仅电脑答题页)',
        AnswerSquare: '是否发布到答题广场',
        OtherSettings: '其他设置',
        CustomJump: '答题完成后自定义跳转',
        SettableVariables: '可设置变量，举例',
        QuestionnaireIdentification: '问卷标识',
        UserId: '用户ID，仅对登录答题有效',
        ThirdParty: '第三方对接系统ID，仅对对接答题有效',
        UniqueId: '每个答题者唯一ID"',
        Staging: '开启答卷暂存',
        ThirdPartyTitle: '第三方接口对接设置',
        SatisfactionScore: '是否启用满意度得分汇总',
        TotalScoreFormula: '总分公式',
        RandomSettings: '随机设置',
        DockingSettings: '对接设置',
        IsTheQuestionnaireValid: '问卷是否有效',
        SetEffectiveTime: '设置有效时间(天)',
        SynchronizeSamples: '同步样本参数设置',
        RuleSettings: '问卷规则设置',
        SampleParameters: '样本参数设置',
        Add: '添加',
        FieldName: '字段名称',
        EnglishName: '字段英文名称',
        Close: '关 闭',
        PleaseEnterAFieldName: '请输入字段名称',
        PleaseEnterAnEnglishName: '请输入字段英文名称',
        ReturnVisitChannels: '回访渠道',
        FollowUpType: '回访类型',
        ValidOrNot: '是否有效',
        DeleteIt: '确定删除吗？',
        AddRuleSettings: '添加问卷规则设置',
        RuleType: '规则类型',
        SelectARuleType: '请选择规则类型',
        RuleChannel: '规则渠道',
        SelectARuleChannel: '请选择规则渠道',
        EditQuestionnaireRuleSettings: '编辑问卷规则设置',
        NameOfFollowUpVisit: '回访名称',
        RuleName: '规则名称',
        ModifyQuestionnaireRules: '修改问卷规则设置',
        WeChatSettings: '微信设置',
        QuerySettings: '查询设置',
        SampleSettings: '样本设置',
        PrizesAndRedEnvelopes: '奖品与红包',
        JumpToTheSpecifiedPage: '跳转到指定页面 (例 http://www.baidu.com)',
        PleaseEnterTheAddress: '请输入地址',
        PleaseSelectWhetherItIsValid: '请选择是否有效',
        DoNotSet: '不设置',
        RandomizeByQuestion: '按题目随机',
        RandomByPage: '按分页随机',
        PiecewiseRandom: '分段随机',
        NewlyAdded: '新增',
        StartingQuestion: '从开始题',
        StartNum: '题号不得小于1并且大于总题数',
        ToTheEndQuestion: '到结束题',
        EndNum: '题号不得小于1并且大于总题数',
        Randomizing: '随机抽取',
        TheCurrentRangeOnlyHas:'当前范围只有',
        Questions: '道题',
        Question: '题',
        FromStartPage: '从开始页',
        pageStartNum: '页码不得小于1并且大于总页数',
        ToEndPage: '到结束页',
        PageEndNum: '页码不得小于1并且大于总页数',
        Page: '第',
        Pages: '页',
        NumberOfQuestions: '题目数',
        ShowOnlySomeTitlesOnThisPage: '只显示此页部分题目',
        RandomFunction: '随机功能',
        RemoveObstaclesFrom: '开通',
        TheCurrentPageHas: '当前页有',
        Tip: '提示',
        CheckOn: '如果问卷中包含“逻辑设置”“关联逻辑”“引用逻辑”，设置随机抽题后可能会导致这些逻辑失效，请检查！',
        MoreThanTwoQuestions: '问卷题目超过两题以上才能选择此项',
        GotIt: '知道了',
        OverTwoPages: '问卷页数超过两页以上才能选择此项',
        Yes: '是',
        No: '否',
    },
  };